module.exports = __webpack_public_path__ + "static/media/savvy-ipfs-webui.f77e2be9.svg";